import { forwardRef } from 'react';
import { Input } from 'semantic-ui-react';

const CustomInput = forwardRef((props: any, ref) => {
  return <Input {...props} ref={ref} icon="calendar alternate outline" />;
});

export default CustomInput;
